import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
import type {
  Cart
} from '@bee-hole/api';
export const useOCart = (id: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // //console.log("useOCartmethodcontext---------", context.useApiError);
  const { set: setError } = useApiError();
  // Shared ref holding the response from the API
  const result = sharedRef(null, `useOCart-${id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useOCart-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useOCart-error-${id}`);

  // 发起支付
  const load = async () => {
    try {
      loading.value = true;
      // console.log("pay参数---------", customQuery);
      const res = await context.$xbuy.api.customCartLoad({});
      // context.useApiError.set(res); 
      const cart: Cart = {
        list: res.data?.list ? res.data.list : [],
        total: res.data?.list ? res.data.list.lengh : 0,
        setType: res.data?.setType ? res.data.setType : 0
      };
      result.value = cart;
      if (res && res.code === 0) {
        error.value = null;
        loading.value = false;
      } else {
        error.value = res.message;
        if (res && res.code) {
          setError({ code: res.code, message: res.message });
        }
      }
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };
  const addItem = async ({ product, quantity, customQuery }) => {
    try {
      loading.value = true;
      let skuId = 0;
      if (!(!product || !product.skus || product?.skus?.length === 0)) {
        skuId = product.skus[0].skuId;
      }
      if (!(!customQuery || !customQuery.skuId)) {
        skuId = Number(customQuery.skuId);
      }
      const x = { sku_id: skuId, num: quantity, good_id: product.goodId };
      const data = await context.$xbuy.api.customAddCart(x);
      if (data && data.code && data.code > 0) {
        setError(data);
        throw new Error(data.message);
      } else if (data && data.code === 0) {
        // setError(data);
      }
      loading.value = false;
      // console.log("pay参数---------", customQuery);
      await load();
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };
  const removeItem = async ({ customQuery }) => {
    try {
      loading.value = true;
      const paramsData = { skuId: customQuery?.sku_id };
      const removeRes = await context.$xbuy.api.customCartRemove(paramsData);
      if (removeRes && removeRes.code && removeRes.code > 0) {
        setError(removeRes);
        throw new Error(removeRes.message);
      }
      await load();
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };
  const updateItemQty = async ({ product, quantity, customQuery }) => {
    const paramsData = { skuId: product?.skuId, num: quantity };
    if (!customQuery?.refresh) {
      const updateRes = await context.$xbuy.api.customUpdateCart(paramsData);
      if (updateRes && updateRes.code && updateRes.code > 0) {
        setError(updateRes);
        throw new Error(updateRes.message);
      }
    }
    await load();
  };
  const clear = async () => {
    const result = await context.$xbuy.api.customClearCart();

    if (result && result.code && result.code > 0) {
      setError(result);
      throw new Error(result.message);
    }
    // console.log('清空结果-----------', data);
    await load();
  };
  const isInCart = () => {
    return false;
  };
  return {
    load,
    addItem,
    removeItem,
    updateItemQty,
    clear,
    isInCart,
    cart: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
